import React, { Component } from "react";
import {
  Card,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Status,
} from "ui-kit-ck-consultant";

import {
  getCurrencyValue,
  getPercentageValue,
  getValue,
} from "../../utils/general";

export default class Details extends Component {
  render() {
    return (
      <Card
        title="Détails"
        className="mb-10 mb-20-xl"
        classNameChildren="overflow-x-auto"
      >
        <Table className="m-auto">
          <Thead>
            <Tr>
              <Th>Volume total cloturé</Th>
              <Th>Montant moyen HT</Th>
              <Th colSpan={2}>Montant total HT</Th>
              <Th>Délai mission - dépôt (j)</Th>
              <Th>Taux cloturé</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{this.props.data.total.countClosed}</Td>
              <Td>{getCurrencyValue(this.props.data.total.average)}</Td>
              <Td colSpan={2}>
                {getCurrencyValue(this.props.data.total.price)}
              </Td>
              <Td>{getValue(this.props.data.total.delai)}</Td>
              <Td>
                <Status
                  className="w-100"
                  text={getPercentageValue(this.props.data.total.taux)}
                />
              </Td>
            </Tr>
          </Tbody>
          <Thead>
            <Tr>
              <Th>Volume R cloturé</Th>
              <Th>Coût moyen HT</Th>
              <Th colSpan={2}>Coût total HT</Th>
              <Th>Délai mission - dépôt (j)</Th>
              <Th>Taux R cloturé</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{this.props.data.R.countClosed}</Td>
              <Td>{getCurrencyValue(this.props.data.R.average)}</Td>
              <Td colSpan={2}>{getCurrencyValue(this.props.data.R.price)}</Td>
              <Td>{getValue(this.props.data.R.delai)}</Td>
              <Td>
                <Status
                  className="w-100"
                  text={getPercentageValue(this.props.data.R.taux)}
                />
              </Td>
            </Tr>
          </Tbody>
          <Thead>
            <Tr>
              <Th>Volume R cloturé agréé</Th>
              <Th>Coût moyen HT</Th>
              <Th colSpan={2}>Coût total HT</Th>
              <Th>Délai mission - dépôt (j)</Th>
              <Th>Taux R cloturé agréé</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{this.props.data.R_approved.countClosed}</Td>
              <Td>{getCurrencyValue(this.props.data.R_approved.average)}</Td>
              <Td colSpan={2}>
                {getCurrencyValue(this.props.data.R_approved.price)}
              </Td>
              <Td>{getValue(this.props.data.R_approved.delai)}</Td>
              <Td>
                <Status
                  className="w-100"
                  text={getPercentageValue(this.props.data.R_approved.taux)}
                />
              </Td>
            </Tr>
          </Tbody>
          <Thead>
            <Tr>
              <Th>Volume R cloturé non agréé</Th>
              <Th>Coût moyen HT</Th>
              <Th colSpan={2}>Coût total HT</Th>
              <Th>Délai mission - dépôt (j)</Th>
              <Th>Taux R cloturé non agréé</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{this.props.data.R_no_approved.countClosed}</Td>
              <Td>{getCurrencyValue(this.props.data.R_no_approved.average)}</Td>
              <Td colSpan={2}>
                {getCurrencyValue(this.props.data.R_no_approved.price)}
              </Td>
              <Td>{getValue(this.props.data.R_no_approved.delai)}</Td>
              <Td>
                <Status
                  className="w-100"
                  text={getPercentageValue(this.props.data.R_no_approved.taux)}
                />
              </Td>
            </Tr>
          </Tbody>
          <Thead>
            <Tr>
              <Th>Volume NR cloturé</Th>
              <Th>VRADE moyenne HT</Th>
              <Th colSpan={2}>VRADE totale HT</Th>
              <Th>Délai mission - dépôt (j)</Th>
              <Th>Taux NR cloturé</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{this.props.data.NR.countClosed}</Td>
              <Td>{getCurrencyValue(this.props.data.NR.average)}</Td>
              <Td colSpan={2}>{getCurrencyValue(this.props.data.NR.price)}</Td>
              <Td>{getValue(this.props.data.NR.delai)}</Td>
              <Td>
                <Status
                  className="w-100"
                  text={getPercentageValue(this.props.data.NR.taux)}
                />
              </Td>
            </Tr>
          </Tbody>
          <Thead>
            <Tr>
              <Th>Taux VEI</Th>
              <Th>Taux préjudice esthétique</Th>
              <Th>Nombre préjudice esthétique</Th>
              <Th>Cout moyen préjudice esthétique</Th>
              <Th>Gain total préjudice esthétique</Th>
              <Th>Gain moyen préjudice esthétique</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{getPercentageValue(this.props.data.other.VEI)}</Td>
              <Td>
                {getPercentageValue(
                  this.props.data.other.averageAestheticPrevention
                )}
              </Td>
              <Td>{this.props.data.other.aestheticPrevention}</Td>
              <Td>
                {getCurrencyValue(
                  this.props.data.other.priceAestheticPrevention
                )}
              </Td>
              <Td>
                {getCurrencyValue(
                  this.props.data.other.gainAestheticPrevention
                )}
              </Td>
              <Td>
                {getCurrencyValue(
                  this.props.data.other.averageGainAestheticPrevention
                )}
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </Card>
    );
  }
}
